import { Column, DateColumn, GridPreLoaded } from "@repo/ui";

import { useRepQueries } from "../../../api/repApi";
import { Rep } from "../../../models";

const columns = [
	new Column("Agent ID", "login"),
	new Column("First Name", "firstName"),
	new Column("Last Name", "lastName"),
	new Column("Last Four SSN", "lastFourSSN"),
	new Column("Status", "statusName"),
	new Column("Email", "email"),
	new DateColumn("Start Date", "startDate").dateOnly(),
	new Column("State", "state"),
] as Column<Rep>[];

export function PotentialDuplicatesGrid() {
	const { useDuplicateRepsQuery } = useRepQueries();
	const query = useDuplicateRepsQuery();

	return (
		<GridPreLoaded
			id="potDuplicatesGrid"
			columns={columns}
			keyProperty="repId"
			values={query.data ?? []}
			loading={!query.loaded}
			getData={() => query.clearQuery()}
		/>
	);
}
